import { getDomain } from 'tldts';

export const normalizeUrlToDomain = (url: string): string | null => {
  try {
    let cleanUrl = url.trim();
    if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://')) {
      cleanUrl = 'https://' + cleanUrl;
    }
    
    const domain = getDomain(cleanUrl);
    return domain; // Returns eTLD+1 (e.g., "example.com")
  } catch (e) {
    console.warn('Failed to normalize URL:', url, e);
    return null;
  }
};

// Deduplicate URLs by hostname+pathname (ignore protocol/trailing slash)
export const deduplicateUrls = (urls: string[]): string[] => {
  const seen = new Set<string>();
  const result: string[] = [];
  
  for (const url of urls) {
    try {
      const parsed = new URL(url.startsWith('http') ? url : `https://${url}`);
      const normalized = `${parsed.hostname}${parsed.pathname}`.replace(/\/$/, '');
      
      if (!seen.has(normalized)) {
        seen.add(normalized);
        result.push(url);
      }
    } catch (e) {
      if (!seen.has(url)) {
        seen.add(url);
        result.push(url);
      }
    }
  }
  
  return result;
};

export const getFavicon = (domain: string): string => {
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
};

export const cleanUrl = (url: string): string => {
  try {
    // Remove trailing slashes, anchors, query params for cleaner display
    const urlObj = new URL(url);
    return `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}`.replace(/\/+$/, '');
  } catch {
    return url;
  }
};
